import { render } from "./Page23.vue?vue&type=template&id=91ea60de"
import script from "./Page23.vue?vue&type=script&lang=js"
export * from "./Page23.vue?vue&type=script&lang=js"

import "./Page23.vue?vue&type=style&index=0&id=91ea60de&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__